/* eslint-disable react/destructuring-assignment */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-return-assign */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Checkbox, Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider } from 'react-intl';
import CustomMultipleCheckbox from './CustomMultipleCheckboxes.settingsForm';
import getLocalParams from '../localizationCustoms';

const CustomMultipleCheckboxes = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.setValue = this.setValue.bind(this);
    this.checked = this.checked.bind(this);
    this.getTypelist = this.getTypelist.bind(this);
  }

  setValue = (v) => {
    const { value } = this.state;
    const { onChange } = this.props;

    if (value && value.selectedValues) {
      if (value.selectedValues.includes(v)) {
        this.setState({
          value: {
            selectedValues: value.selectedValues.filter((c) => c !== v),
            review: { label: this.props.component.useReviewLabel ? this.props.component.reviewLabel : this.props.component.label, typelist: this.getTypelist() },
          },
        }, () => {
          onChange(this.state.value);
        });
      } else if (!value.selectedValues.includes(v)) {
        this.setState((prevState) => ({
          value: { selectedValues: [...prevState.value.selectedValues, v], review: { label: this.props.component.useReviewLabel ? this.props.component.reviewLabel : this.props.component.label, typelist: this.getTypelist() } },
        }), () => {
          onChange(this.state.value);
        });
      }
    } else {
      this.setState({
        value: { selectedValues: [v], review: { label: this.props.component.useReviewLabel ? this.props.component.reviewLabel : this.props.component.label, typelist: this.getTypelist() } },
      }, () => {
        onChange(this.state.value);
      });
    }
  };

  getTypelist = () => {
    const options = {};
    const { component } = this.props || undefined;
    const { values } = component;
    values.forEach((option) => {
      options[option.value] = option.label;
    });
    return options;
  };

  checked = (checkboxValue) => {
    const { value } = this.state;
    if (value && value.selectedValues) {
      if (value.selectedValues.includes(checkboxValue)) { return true; }
    }
    return false;
  };

  render() {
    const { component } = this.props || undefined;
    const { values, hideCustomLabel, label, tooltip } = component;
    return (
      values !== undefined && (
        <div>
          {!hideCustomLabel && (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <label className="label-question">
                <FormattedMessage id={label} defaultMessage={label} />
              </label>
              {tooltip !== '' && (
                <Tooltip id="multiplecheckboxes_tooltip" primary>
                  <FormattedMessage id={tooltip} defaultMessage={tooltip} />
                </Tooltip>
              )}
            </div>
          )}
          {values.map((checkboxIndex) => (
            <Checkbox
              primary
              disabled={this.props.disabled}
              style={{ margin: '0px', padding: '0px' }}
              name="check"
              id={`id_checkbox${Math.random() * 0xffffffffffff}`}
              key={`key_checkbox${Math.random() * 0xffffffffffff}`}
              value={checkboxIndex.value}
              onChange={(newValue) => this.setValue(newValue)}
              checked={this.checked(checkboxIndex.value)}
            >
              <FormattedMessage id={checkboxIndex.label} defaultMessage={checkboxIndex.label} />
            </Checkbox>
          ))}
        </div>
      )
    );
  }
};

export default class MultipleCheckboxesComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Multiple Checkboxes',
      group: 'basic',
      icon: 'check-square',
      documentation: '',
      weight: 50,
      schema: MultipleCheckboxesComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'custommultiplecheckboxes',
      },
      ...extend,
    );
  }

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  static editForm = CustomMultipleCheckbox;

  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomMultipleCheckboxes
          ref={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          onChange={this.updateValue} // The onChange event to call when the value changes.
        />
      </IntlProvider>,
      element,
      () => (this.reactInstance = instance),
    );
  }

  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
